export const Shadows = {
    LeftShadowSpace: 20,
    RightShadowSpace: 20,
    TopShadowSpace: 2,
    HorizontalShadowSpace: 40,
};
